module.exports = __webpack_public_path__ + "static/siebe-8a34de454252b08e3ef99f43f0e55c7d.jpeg";